/**
 * readOrgSeed — one-time read of what the Month/Week first events request
 * needs, SSR-injected by `CalendarService::month()/week()` into
 * `window.serverData` (`calendarOrgSeed` + the existing `_organization`).
 *
 * Every field degrades to `null` (= the pre-seed behaviour) when absent or
 * malformed.
 *
 * @module readOrgSeed
 */

function validTimeZone(tz) {
	if (typeof tz !== 'string' || !tz.trim()) return null;
	try {
		new Intl.DateTimeFormat('en-US', { timeZone: tz.trim() });
		return tz.trim();
	} catch (_) {
		return null;
	}
}

/**
 * @returns {{orgTimezone: string|null, orgUnique: string|null}} `orgUnique` is the
 *   canonical slug (the one bootstrap returns), not the URL path segment.
 */
export function readOrgSeed() {
	const sd = typeof window !== 'undefined' ? window.serverData || {} : {};
	const seed =
		sd.calendarOrgSeed && typeof sd.calendarOrgSeed === 'object' ? sd.calendarOrgSeed : {};
	const org = sd._organization && typeof sd._organization === 'object' ? sd._organization : {};
	return {
		orgTimezone: validTimeZone(seed.orgTimezone),
		orgUnique: typeof org.unique === 'string' && org.unique ? org.unique : null
	};
}

export default readOrgSeed;
